import { Tab } from 'semantic-ui-react'
import styled, { css } from 'styled-components'

import { FlexRow, Icon } from '..'
import { TabItemProps } from './types'

export const TabContainer = styled(({ sticky, ...rest }) => (
  <FlexRow display="flex" {...rest} />
))`
  ${({ theme, noMargin, sticky }) => css`
    width: ${noMargin ? '100%' : 'calc(100% + 2em)'};
    margin: ${noMargin ? '0' : '-1em 0 2em -1em'};
    background: ${theme.colors.lightGrey};
    flex-direction: 'row';

    ${theme.mediaQueries.mobile} {
      border-top: 1px solid #dbe2ef;
    }

    ${sticky &&
    css`
      position: sticky;
      top: 55px;
      z-index: 1000;

      ${theme.mediaQueries.mobile} {
        border-top: 1px solid #dbe2ef;
        top: 55px;
      }
    `}
  `}
`

export const StyledTab = styled(Tab)`
  &&& {
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    border-top-left-radius: 2px;

    .ui.secondary.pointing.menu {
      border-bottom: none;
    }

    .menu .item {
      padding: 18px 24px !important;
      border-right: 1px solid #e3e8ea !important;

      &.active.active {
        background: #fff;
        border-color: transparent;
      }

      &.disabled {
        opacity: 0.5;
      }
    }
  }
`

export const TabItem = styled.div<TabItemProps>`
  ${({ theme, notify }) =>
    notify &&
    css`
      :after {
        font-family: 'Roboto';
        background-color: ${theme.colors.red};
        border-radius: 10px;
        width: 23px;
        height: 18px;
        color: white;
        font-size: 9px;
        font-weight: 400;
        position: absolute;
        top: 5px;
        right: 5px;
        content: '${notify}';
        line-height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `}
`

export const PopupMenuTrigger = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  min-height: 50px;
  min-width: 60px;
  cursor: pointer;
`

export const PopupMenuIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-angle-double-right',
})`
  &&& {
    font-size: 11px !important;
    top: -3px;
    margin-right: 0;
  }
`

export const AddTabIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-plus',
  size: 'large',
})`
  margin-left: 24px !important;
`

export const TabWrapper = styled.div`
  ${({ theme }) => css`
    margin: -1.5em -0.5em -0.5em -0.5em;

    ${theme.mediaQueries.mobile} {
      margin: 0;

      > div {
        border-top: 0;
      }
    }
  `}
`
